import { AdminPermissions } from "./types";

export const checkPermission = (permissions: AdminPermissions | undefined, section: string, action: string): boolean => {
  if (!permissions) return false;

  const sectionPermissions = permissions[section as keyof AdminPermissions] as any;
  if (!sectionPermissions) return false;

  return Boolean(sectionPermissions[action]);
};

export const hasAnyPermission = (
  permissions: AdminPermissions | undefined,
  section: string,
  actions: string[]
): boolean => {
  if (!permissions) return false;

  return actions.some(action => checkPermission(permissions, section, action));
};